import { createFileRoute } from '@tanstack/react-router';
import { CrmPreviewPage } from '@/pages/Crm/CrmPreviewPage';
import { AclRoute, withPermission } from '@/lib/acl';
import { crmNavItem } from '@/lib/crm/crm-nav';

function Preview() {
  return <CrmPreviewPage navId="contacts" />;
}

export const Route = createFileRoute('/crm/contacts')({
  component: withPermission(Preview, { key: crmNavItem('contacts').access, route: AclRoute.CRM, resourceLabel: 'Contacts' }),
});
